var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['callout', _vm.calloutClass],attrs:{"aria-live":"polite","role":"alert"}},[(_vm.noIcon)?_vm._t("default"):_c('div',{staticClass:"d-flex justify-content-start"},[_c('b-icon',{staticClass:"mr-3 align-self-center",attrs:{"icon":_vm.icon,"font-scale":1.5}}),_vm._v(" "),_c('div',[_vm._t("default")],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }